import React, {Component} from "react";
import {Link} from "react-router-dom";
import {observer} from "mobx-react";
import {mesAutobind} from "@posco/posco-shared";


@mesAutobind
@observer
class MenuList extends Component {
  renderMenu(props, menu) {
    return props.depth2 && props.depth2.length > 0
      ? <>
        <span
          onClick={() => {
            this.props.menuStatueSet({...this.props.menuStatue, [menu]: !this.props.menuStatue[menu]});
          }}>{props.menuNm}</span>
        <ul>
          {props.depth2.map(props =>
            <li key={props.pattMenuId}
                className={this.props.activePattMenuIdArray.includes(props.pattMenuId) ? "thisPage" : null}
            >
              {/* pgmUrl 없으면 클릭, 마우스표시 안되게 처리*/}
              {props.pgmUrl ?
                <Link
                  key={props.pattMenuId}
                  onClick={this.props.adding}
                  pattmenuid={props.pattMenuId}
                  pattmenuid1={props.pattMenuId1}
                  to={props.pgmUrl + "/" + this.props.projectNumber || ""}
                  pgmurl={props.pgmUrl + "/" + this.props.projectNumber || ""}
                  pageid={props.pageId}
                  style={{whiteSpace: "pre"}}
                >
                  {props.menuNm}
                </Link>
                :
                <a style={{whiteSpace: "pre", cursor: "default"}}>{props.menuNm}</a>
              }

            </li>)}
        </ul>
      </>
      : <span
        onClick={() => {
          this.props.menuStatueSet({...this.props.menuStatue, [menu]: !this.props.menuStatue[menu]});
        }}
        key={props.pattMenuId}
        className={this.props.activePattMenuIdArray.includes(props.pattMenuId) ? "thisPage" : null}
      >
        {/* pgmUrl 없으면 클릭, 마우스표시 안되게 처리*/}
        {props.pgmUrl ?
          <Link
            key={props.pattMenuId}
            onClick={this.props.adding}
            pattmenuid={props.pattMenuId}
            pattmenuid1={props.pattMenuId1}
            to={props.pgmUrl + "/" + this.props.projectNumber || ""}
            pgmurl={props.pgmUrl + "/" + this.props.projectNumber || ""}
            pageid={props.pageId}
            style={{whiteSpace: "pre"}}
          >
            {props.menuNm}
          </Link>
          :
          <a style={{whiteSpace: "pre", cursor: "default"}}>{props.menuNm}</a>
        }
      </span>;
  }

  render() {
    return (
      <>
        {this.props.menuList.map(props => {
          return (
            // //depth2가 있고 menuStatue가 true거나 activePattMenuId1Array에 pattMenuId가 있으면 메뉴 열림
            //  ${(props.depth2 && props.depth2.length > 0) &&
            //                  (this.props.menuStatue[props.pattMenuId] || this.props.this.props.activePattMenuId1Array.includes(props.pattMenuId)) ? "shown" : "hidden"}
            // //메뉴 아이콘
            // ${props.envEquipImageName}
            // //depth2가 있으면 사이드 화살표 아이콘 추가
            // ${(props.depth2 && props.depth2.length > 0) && "actArrow"}
            <div key={props.pattMenuId}
                 className={`
              ${(props.depth2 && props.depth2.length > 0) &&
                 (this.props.menuStatue[props.pattMenuId] || this.props.activePattMenuId1Array.includes(props.pattMenuId)) ? "shown" : "hidden"}
              ${props.envEquipImageName}
              ${(props.depth2 && props.depth2.length > 0) && "actArrow"}
              `}>
              {this.renderMenu(props, props.pattMenuId)}
            </div>
          );
        })}
      </>
    );
  }
}

export default MenuList;
